import {
    PINCODE_REQUEST,
    PINCODE_SUCCESS,
    PINCODE_FAILURE,
} from "../constants/ActionTypes";

const initialState = {
    loading: false,
    pincodeData: [],
    error: null,
};

export default function pincodeReducer(state = initialState, action) {
    switch (action.type) {
        case PINCODE_REQUEST:
            return {
                ...state,
                loading: true,
            };
        case PINCODE_SUCCESS:
            return {
                ...state,
                // always replacing data
                pincodeData: action.data.data,
                loading: false,
                // if adding data
                // data: [...state.data, action.data]
            };
        case PINCODE_FAILURE:
            return {
                ...state,
                loading: false,
                error: action.error,
            };
        default:
            return state;
    }
}
